import resolveResponse from 'contentful-resolve-response'
import fetchQueryWrapper from '../network/fetchQueryWrapper'
import { CONTENT_TYPE } from '../utils/contentTypes'
import logger from '../utils/winston-logger/winston-logger'
import extractLivePage from '../data/transformers/extractLivePage'
import LivePage from '../components/LivePage/LivePage'

const MAIN_LIVESTREAM = '4MfowdajNYegQfPidtWFrk'

const Live = ({ title, src, type, captions, thumbnail }) => (
  <LivePage title={title} src={src} type={type} captions={captions} thumbnail={thumbnail} />
)

export async function getServerSideProps() {
  try {
    const live = await fetchQueryWrapper(
      {
        content_type: CONTENT_TYPE.VIDEO,
        'sys.id': MAIN_LIVESTREAM
      },
      resolveResponse
    )

    return { props: extractLivePage(live) }
  } catch (error) {
    logger.error('Error in live.page.js ', error)
    return { notFound: true }
  }
}

export default Live
